import React from 'react';
import ReactDOM from 'react-dom/client';

// Import Bootstrap CSS and JS (bundle includes Popper.js for dropdowns/tooltips)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
